<template lang="pug">
div
  section.u-mt-md
    HelpHeader
  section.u-mt-md
    NuxtChild
  .u-mb-md

</template>

<script>
import HelpHeader from '~/components/HelpHeader';

export default {
  components: {
    HelpHeader
  },
  meta: {
    logoText: 'knowledgebase'
  }
};
</script>
